import { PaginationRequest, PaginationResponse } from '@repo/ui/data-table'

import { Center, CenterVersions } from '../../lib/types/models/center/center'
import { CenterFilter } from '../../lib/types/models/center/center-filter'
import { encodeNestedObject } from '../../lib/utils/functions/misc.functions'
import { API, constructApiUrl } from '../apis.config'
import { restApiClient } from '../rest-api-client'

export function getCenters(input: PaginationRequest<CenterFilter, CenterVersions> = {}) {
  return restApiClient
    .url(
      encodeNestedObject<PaginationRequest>(constructApiUrl(API.centers.getAll.url, null), input)
    )
    .get<PaginationResponse<Center>>()
}
